import { render } from "./PaymentChart.vue?vue&type=template&id=2788a79a"
import script from "./PaymentChart.vue?vue&type=script&lang=js"
export * from "./PaymentChart.vue?vue&type=script&lang=js"

import "./PaymentChart.vue?vue&type=style&index=0&id=2788a79a&lang=css"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__